/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_REPORT_DETAIL(state, data) {
    state.detail = data;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_SALARY_SETTING(state, data) {
    state.salary_setting = data;
  },
  SET_SALARY_SETTING_HISTORY(state, data) {
    state.salary_setting_history = data;
  },
  SET_LIST_REPORT(state, data) {
    state.list = data;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_FILTERS(state, data) {
    state.filters = data;
  },
  UPDATE_SALARY_SETTING(state, data) {
    const pos = state.salary_setting
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);

    state.salary_setting.splice(pos, 1, data);
  },
};
